// @flow
import React from "react";

import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {strings} from "../../../../config";
import {AcceptTermsLabel, AcceptTermsSelectionButton} from "./AcceptTermsStyle";
import AppSelectors from "../../../../Store/Ducks/App/selectors";
import AppOperations from "../../../../Store/Ducks/App/operations";

const AcceptTerms = (props) => {
    return (
        <AcceptTermsSelectionButton onClick={props.onAcceptTermsClick}>
            <AcceptTermsLabel>
                {strings.welcome_page_button_text}
            </AcceptTermsLabel>
        </AcceptTermsSelectionButton>
    );
};

const mapStateToProps = (state, props) => {
    return {
        app: AppSelectors.appSelector(state),
    };
};

const mapActionsToProps = (dispatch, props) => {
    return bindActionCreators(
        {
            onAcceptTermsClick: AppOperations.acceptTermsClick
        },
        dispatch);
};

export default connect(mapStateToProps, mapActionsToProps)(AcceptTerms);



// WEBPACK FOOTER //
// ./src/Components/Screen/WelcomePage/AcceptTerms/AcceptTerms.js